const OFFICE_EXTENSIONS = new Set(['docx', 'pptx']);

export const getShareableFileUrl = (candidate: string | null | undefined): string => {
    if (!candidate) {
        return '';
    }

    try {
        const parsed = new URL(candidate);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            return '';
        }

        parsed.hash = '';
        return parsed.toString();
    } catch {
        return '';
    }
};

export const isOfficeDocument = (pathOrUrl: string): boolean => {
    return OFFICE_EXTENSIONS.has(getFileExtension(pathOrUrl));
};

export const getFileExtension = (pathOrUrl: string): string => {
    if (!pathOrUrl) {
        return '';
    }

    const cleanedPath = pathOrUrl.split('?')[0].split('#')[0] || '';
    const lastSegment = cleanedPath.split('/').pop() || '';
    const extension = lastSegment.includes('.') ? lastSegment.split('.').pop() : '';

    return (extension || '').toLowerCase();
};
